module.exports = __webpack_public_path__ + "media/Video (10).e0e76f7e.mp4";